
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useProfile } from "../../hook/useProfile";

const Sidebar = ({
  showSidebar,
  sidebarMenus = [],
  activeSidebar,
  feedType,
  onNavigate,
  onLogout,
}) => {
  const [openMenu, setOpenMenu] = useState(null);
  const { isProfileInfo } = useProfile();
  const isRevolutionPermission = isProfileInfo?.revolutionPermission;

  //  IMPORTANT: Auto open dropdown when child is active (Settings/KYC etc)
  useEffect(() => {
  if (!activeSidebar) return;

  const parentMenu = sidebarMenus.find(
    (menu) =>
      menu.children &&
      menu.children.some((child) => child.key === activeSidebar)
  );

  //  Only update if different (prevent extra re-render)
  if (parentMenu && openMenu !== parentMenu.key) {
    setOpenMenu(parentMenu.key);
  }
}, [activeSidebar, sidebarMenus, openMenu]);


  const handleMenuClick = (item) => {
    if (item.children) {
      // Parent click → open dropdown + make parent active (orange)
      setOpenMenu((prev) => (prev === item.key ? null : item.key));
      onNavigate({ key: item.key }); // parent highlight
    } else {
      onNavigate(item);
    }
  };

  return (
    <div
      className={`feed-sidebar-container p-0 col-lg-3 col-md-3 d-md-block ${showSidebar ? "sidebar-hide" : "sidebar-show"
        }`}
    >
      <aside className="feed-sidebar px-2 px-sm-3 py-4">
        <ul className="left-menu">
          {sidebarMenus
            .filter((item) => {
              if (item.showWhen && item.showWhen !== feedType) return false;

              // hide revolution-my when no permission
              if (item.key === "revolution/my" && !isRevolutionPermission) {
                return false;
              }
              return true;
            })
            .map((item) => {
              const isParentActive = activeSidebar === item.key;

              return (
                <React.Fragment key={item.key}>
                  {/* PARENT MENU (Settings, Revolution, etc) */}
                  <li
                    className={`menu-item mb-1 ${isParentActive ? "active" : ""
                      }`}
                    onClick={() => handleMenuClick(item)}
                  >
                    <FontAwesomeIcon icon={item.icon} />
                    <span>{item.label}</span>

                    {item.children && (
                      <span
                        className={`ms-auto arrow-icon ${openMenu === item.key ? "open" : ""
                          }`}
                      >
                        <FontAwesomeIcon icon={faAngleRight} />
                      </span>
                    )}
                  </li>

                  {/* SUB MENU */}
                  {item.children && (
                    <ul
                      className={`submenu ${openMenu === item.key ? "submenu-open" : ""
                        }`}
                    >
                      {item.children
                        .filter((child) =>
                          child.key === "revolution-my"
                            ? isRevolutionPermission === true
                            : true
                        )
                        .map((child) => {
                          return (
                            <li
                              key={child.key}
                              className={`submenu-item ${activeSidebar === child.key ? "active" : ""
                                }`}
                              onClick={(e) => {
                                e.stopPropagation(); 
                                onNavigate(child); 
                              }}
                            >
                              {child.label}
                            </li>
                          );
                        })}
                    </ul>
                  )}
                </React.Fragment>
              );
            })}
        </ul>
      </aside>
    </div>
  );
};

export default Sidebar;
